<template>
  <div>
    <v-row>
      <!-- <v-col cols="12">
        <v-alert outlined border="left" color="warning" dense class="mb-0">
          Chọn khoảng thời gian và xác nhận để xuất dữ liệu tính lương
        </v-alert>
      </v-col> -->
      <v-col cols="12" md="8">
        <DateRangeFilter
          :label="$t('Từ - Đến')"
          :placeholder="$t('Từ - Đến')"
          name="data_time"
          sort-name="data_time"
          :default-value="defaultDate"
          @onFilter="onFilterChange"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-btn block color="success" @click="downloadPayroll">
          {{ $t("Xác nhận") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Payroll",
  components: {
    DateRangeFilter: () => import("@/components/table/DateRangeFilter"),
  },
  data: () => ({
    filters: {},
    isLoading: false,
  }),
  computed: {
    defaultDate() {
      return [
        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      ];
    },
  },
  mounted() {},
  methods: {
    onFilterChange(filter) {
      this.filters = { ...this.filters, [filter.name]: filter.value };
    },
    onSortChange(sort) {
      this.filters = { ...this.filters, ...sort };
    },

    async downloadPayroll() {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      const filename = `emove_salary_${this.filters.data_time.join(
        "-"
      )}_${this.generateRandomString("6")}`;
      try {
        await this.downloadExcelFile(
          "/payroll/v1/export",
          { ...this.filters },
          filename
        );
        document.getElementById("success_sound_player").play();
        this.isLoading = false;
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
